import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { addApplication } from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SaveChangesButton from "components/Form/SaveChangesButton";

import FormWrapper from "components/Form/FormWrapper";
import Form from "components/Form";
import Input from "components/Form/Input";
import Textarea from "components/Form/Textarea";
import ImageUpload from "components/Form/ImageUpload";
import { cutImageFullPath, handleErrMsg } from "helpers/functions";
import { Col, Row } from "react-bootstrap";
import "styles/applications.css";

const AddApplication = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.applications);

  const [editAppInfoCheck, setEditAppInfoCheck] = useState(false);
  // effects

  // error
  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  const onSubmitDetails = (data) => {
    data.icon = cutImageFullPath(data?.icon);

    dispatch(addApplication({ data, navigate }));
    setEditAppInfoCheck(!editAppInfoCheck);
  };

  if (loading) return <Loader />;
  return (
    <div className="applications">
      <FormWrapper title={"addApplication"} lg={12}>
        {/* <Form onSubmit={onSubmitDetails} > */}
        <Col lg={12}>
          <Form onSubmit={onSubmitDetails}>
            <div className="form-group branches features">
              <Row>
                <Col xs="12">
                  <div className="d-flex justify-content-center align-items-center h-100 ">
                    <ImageUpload
                      name="icon"
                      langId={false}
                      classNames="m-auto"
                      rules={{}}
                    />
                  </div>
                </Col>
                <Row>
                  <Input name="name" locale="ar" langId="name" />
                  <Input name="name" locale="en" langId="name" />

                  <Textarea
                    name="description"
                    locale="ar"
                    langId="description"
                  />
                  <Textarea
                    name="description"
                    locale="en"
                    langId="description"
                  />

                  <Input name="website" langId="appLink" />
                  <Input name="supportEmail" langId="supportEmail" />
                </Row>

                <SaveChangesButton className="mt-2 justify-content-end" />
              </Row>
            </div>
          </Form>
        </Col>
      </FormWrapper>
    </div>
  );
};

export default AddApplication;
